/**
 * Dedupes in-flight JiT cache warm / synthesis by cache key (playback + prefetch).
 * All waiters receive the same resolved value from the leader job.
 */
const inFlight = new Map<string, Promise<unknown>>();

export const isJitAudioBusy = (): boolean => inFlight.size > 0;

export const trackJitSynthesis = <T>(
  cacheKey: string,
  job: () => Promise<T>
): Promise<T> => {
  const existing = inFlight.get(cacheKey);
  if (existing) return existing as Promise<T>;

  const tracked = job().finally(() => {
    inFlight.delete(cacheKey);
  });
  inFlight.set(cacheKey, tracked);
  return tracked;
};
